import { css } from 'styled-components';
import { rem } from '../../../helpers/mixins';

export default {
  wrapper: css`
    margin-top: 50px;
    margin-bottom: 30px;
  `,
  title: css`
    font-size: ${rem(24)};
    margin-bottom: 30px;
  `,
  content: css`
    font-size: ${rem(14)};
    line-height: ${rem(22)};
  `,
  fieldGroup: css`
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    width: 100%;
  `,
  fieldText: css`
    border: 0;
    width: 100%;
    border-bottom: 1px solid #000;
  `,
  fieldLabel: css`
    font-size: ${rem(10)};
  `,
  messageBox: css`
    background-color: #E8E68D;
    padding: 8px 32px;
    margin-bottom: 30px;
  `,
};
